module.exports = __webpack_public_path__ + "img/auth1.a9ddd185.png";